import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { AttachmentRect } from '@src/slide/domain/ui-model/element-modeles/property/attachment/interface';
import { MAX_MEDIA_SIZE } from '@src/slide/domain/ui-model/element-modeles/property/attachment/constants';
import { enumerateGroupItems } from '@src/slide/domain/ui-model/element-modeles/property/group-operation/enumerate';
import { isAttachmentImageElement } from '@src/slide/domain/ui-model/elements/element-judge';

/**
 * 检查是否相交
 * @param ra
 * @param rb
 */
export function isIntersect(ra: AttachmentRect, rb: AttachmentRect) {
    const nonIntersect = (rb.left + rb.width) < ra.left
        || rb.left > (ra.left + ra.width)
        || (rb.top + rb.height) < ra.top
        || rb.top > (ra.top + ra.height);
    return !nonIntersect;
}

/**
 * 判断文档中是否含有附件，由于音视频可以直接随文档导出，这里有两层逻辑
 * 1. 如果有除了音视频图片附件预览态之外的附件，直接返回true
 *
 */
export function hasAttachmentOrMediaExceedsLimit(presentation): {
    hasAttachment: boolean;
    isMediaExceedsLimit: boolean;
} {
    let hasAttachment = false;
    // 使用every替换forEach。是为了终止循环
    presentation?.children?.every?.((slideModel) => {
        let needBreakSlide = false;
        slideModel.children?.every?.((child) => {
            let needBreakElement = false;
            function checkAttachment(element) {
                if (!isAttachmentImageElement(element) && element?.isAttachmentUploaded?.()) {
                    needBreakElement = true;
                    needBreakSlide = true;
                    hasAttachment = true;
                }
            }
            if (child.type === UIModelType.GROUP) {
                enumerateGroupItems(child, (childModel) => {
                    checkAttachment(childModel);
                }, null);
            } else {
                checkAttachment(child);
            }
            return !needBreakElement;
        });
        return !needBreakSlide;
    });
    window.log?.info('hasAttachment=', hasAttachment);
    return {
        hasAttachment,
        isMediaExceedsLimit: false,
    };
}

